import { ChatMessage } from '@twaice-fe/shared/models';
import { Action, createReducer, on } from '@ngrx/store';
import { chatActions } from '../actions';

export const CHAT_FEATURE_KEY = 'chat';

export interface State {
  messages: ChatMessage[];
  isLoading: boolean;
  isSubmitting: boolean;
  error: string | null;
}

export const initialState: State = {
  messages: [],
  isLoading: false,
  isSubmitting: false,
  error: null,
};

const upsertMessage = (messages: ChatMessage[], message: ChatMessage): ChatMessage[] => {
  const index = messages.findIndex((item) => item.timestamp === message.timestamp);
  if (index === -1) {
    return [...messages, message];
  }

  const updated = [...messages];
  updated[index] = message;
  return updated;
};

const chatReducer = createReducer(
  initialState,
  on(chatActions.fetchChatMessages, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(chatActions.loadChatMessagesSuccess, (state, { messages }) => ({
    ...state,
    messages,
    isLoading: false,
    error: null,
  })),
  on(chatActions.loadChatMessagesFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
  on(chatActions.postChatMessage, chatActions.patchChatMessage, chatActions.deleteChatMessage, (state) => ({
    ...state,
    isSubmitting: true,
    error: null,
  })),
  on(chatActions.postChatMessageSuccess, chatActions.patchChatMessageSuccess, (state, { message }) => ({
    ...state,
    messages: upsertMessage(state.messages, message),
    isSubmitting: false,
    error: null,
  })),
  on(chatActions.deleteChatMessageSuccess, (state, { timestamp }) => ({
    ...state,
    messages: state.messages.filter((message) => message.timestamp !== timestamp),
    isSubmitting: false,
    error: null,
  })),
  on(
    chatActions.postChatMessageFailure,
    chatActions.patchChatMessageFailure,
    chatActions.deleteChatMessageFailure,
    (state, { error }) => ({
      ...state,
      isSubmitting: false,
      error,
    })
  )
);

export function reducer(state: State | undefined, action: Action) {
  return chatReducer(state, action);
}
